import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import Api from '../../../../../services/Api';
import Button from '../../../../atoms/Button/Button';
import ElementTypeSelector from '../../../../atoms/ElementTypeSelector/ElementTypeSelector';
import Icon from '../../../../atoms/Icon/Icon';
import './CreateElementModal.scss';

const CreateElementModal = ({
  onItemCreated,
  cityId,
  dynastyId,
}) => {
  const [typeId, setTypeId] = useState(undefined);
  const [name, setName] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const saveComponent = () => {
    if (!typeId) {
      setError('Element type is required');
      return;
    }
    if (!name) {
      setError('Element name is required');
      return;
    }
    setLoading(true);
    Api.post('instances/building-elements', {
      name,
      code_suffix: 'BEN',
      dynasty_id: dynastyId,
      city_id: cityId,
      element_type: typeId,
    }).then((response) => {
      setLoading(false);
      onItemCreated(response.data);
    });
  };
  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <Label>Type</Label>
          <ElementTypeSelector onChanged={e => setTypeId(e.value)} isMulti={false} />
        </FormGroup>
      </Col>
      <Col md={12}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" onChange={e => setName(e.target.value)} value={name} />
        </FormGroup>
      </Col>
      {error !== undefined && (
        <Col md={12} className="d-flex justify-content-end">
          <span className="text-danger">{error}</span>
        </Col>
      )}
      <Col className="d-flex justify-content-end mt-3">
        <Button isLoading={loading} onInvoked={() => saveComponent()}>
          <Icon icon="save" color="#fff" />
          <span className="ms-2">Save</span>
        </Button>
      </Col>
    </Row>
  );
};

CreateElementModal.propTypes = {
  onItemCreated: PropTypes.func.isRequired,
  cityId: PropTypes.number.isRequired,
  dynastyId: PropTypes.number.isRequired,
};

CreateElementModal.defaultProps = {

};

export default CreateElementModal;
